import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import InfoIcon from '@mui/icons-material/Info'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

const PUT_OPTION_TOOLTIP =
    'Investerare som ingått säljoptionsavtal med garantigivaren, motsvarande ett undergarantiåtagande.'

const isPutOptionFlag = (value: boolean | 0 | 1 | null | undefined) => value === true || value === 1

export function InvestorNameCell({
    name,
    investorId,
    putOption,
}: {
    name: string
    investorId: string
    putOption?: boolean | 0 | 1 | null
}) {
    const { t } = useTranslation()

    if (name === '?') {
        return <Typography variant='body3'>{t('components.investorNameCell.unnamed')}</Typography>
    }

    const isPutOption = isPutOptionFlag(putOption)

    return (
        <Box component='span' sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.5 }}>
            <Link to={`/investors/${investorId}`} style={{ fontStyle: isPutOption ? 'italic' : 'normal' }}>
                {name}
            </Link>
            {isPutOption && (
                <Tooltip title={PUT_OPTION_TOOLTIP} placement='top'>
                    <InfoIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                </Tooltip>
            )}
        </Box>
    )
}
